import { handleEmptyString } from 'utils/handleEmptyString'

export const PickUpAddressModel = {
  listPayload: ({ name, serviceId, pagination }) => {
    const { page = 1, perPage = 10 } = pagination

    return {
      name,
      service_id: serviceId,
      page,
      per_page: perPage
    }
  },
  create: (pickUpAddress) => {
    const {
      name
    } = pickUpAddress

    const {
      city,
      state,
      country,
      zipCode,
      address: street,
      addressDetail: supplement,
      district,
      latLong = ''
    } = pickUpAddress?.addressInfo || {}

    const [latitude, longitude] = latLong.split(',')

    return {
      name,
      city_id: city,
      state_id: state,
      country_id: country,
      post_code: zipCode,
      street,
      supplement,
      district,
      latitude,
      longitude
    }
  },
  update: (pickUpAddress) => {
    const {
      name,
      companyId,
      id,
      addressInfo: {
        city,
        state,
        country,
        zipCode,
        address: street,
        addressDetail: supplement,
        district,
        latLong
      }
    } = pickUpAddress

    const parsedPickUpAddress = {
      name,
      company_id: companyId,
      id,
      city_id: handleEmptyString(city),
      state_id: handleEmptyString(state),
      country_id: handleEmptyString(country),
      post_code: handleEmptyString(zipCode),
      street: handleEmptyString(street),
      supplement: handleEmptyString(supplement),
      district: handleEmptyString(district),
      latitude: latLong?.split(',')[0] === '' ? undefined : latLong?.split(',')[0],
      longitude: latLong?.split(',')[1] === '' ? undefined : latLong?.split(',')[1]
    }

    return parsedPickUpAddress
  }
}
